import React from 'react'
import './loader.css'

const Loader = () => {
  return (
    <div className='loader-container'>
      <img src="../images/category/loader.gif" alt="Loading gif" />
    </div>
  )
}

export default Loader